import SatelliteAltOutlinedIcon from '@mui/icons-material/SatelliteAltOutlined';
import CellTowerIcon from '@mui/icons-material/CellTower';

import { LocationMehod } from '../../constants/Constants';
import { ColumnExtendedStrict } from '../../types/ColumnExtended';
import { dateHeader, formatCellDate } from './timeModeCell';
import { linkTo } from '../linkTo';

const renderLocationMethod = (locationMethod) => {
  return locationMethod === LocationMehod.GPS ? (
    <SatelliteAltOutlinedIcon style={{ color: 'green', fontSize: '1.1rem' }} />
  ) : locationMethod === LocationMehod.NETWORK ? (
    <CellTowerIcon style={{ color: 'blue', fontSize: '1.1rem' }} />
  ) : (
    <></>
  );
};

export const makeReaderReportSightingColumn = (enableDeepLinks: boolean) => {
  const col: ColumnExtendedStrict<any>[] = [
    {
      header: 'Serial Number',
      accessorKey: 'serialNumber',
      enableColumnFilter: true,
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row }) =>
        enableDeepLinks && row.original.equipmentId
          ? linkTo('/equipment', row.original.equipmentId, row.original.serialNumber)
          : row.original.serialNumber,
    },
    {
      header: 'Facility',
      accessorKey: 'facilityName',
      enableColumnFilter: true,
      size: 275,
      style: { textAlign: 'left', whiteSpace: 'break-spaces' },
      cell: ({ row }) => row.original.facilityName,
    },
    {
      header: 'DeviceId',
      accessorKey: 'deviceId',
      enableColumnFilter: true,
      size: 150,
      style: { textAlign: 'center' },
      cell: ({ row }) => (enableDeepLinks ? linkTo('/devices', row.original.deviceId, row.original.deviceId) : row.original.deviceId),
    },
    {
      header: 'ULD Status',
      accessorKey: 'equipmentStatus',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
      cell: ({ row }) => row.original.equipmentStatusDescr,
    },
    {
      header: 'Location',
      accessorKey: 'stationIataCode',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
    },
    {
      header: 'Network',
      accessorKey: 'networkCarrierCode',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
    },
    {
      header: 'Content Code',
      accessorKey: 'contentCode',
      enableColumnFilter: false,
      size: 95,
      style: { textAlign: 'center' },
    },
    {
      header: 'ULD Cond.',
      accessorKey: 'condition',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
    },
    {
      header: 'Radio Type',
      accessorKey: 'radioTypeDescr',
      enableColumnFilter: true,
      size: 80,
      style: { textAlign: 'center' },
    },
    {
      header: dateHeader('Last Seen'),
      accessorKey: 'lastSeenDateTime',
      enableColumnFilter: false,
      style: { textAlign: 'center' },
      cell: ({ row, table }) => formatCellDate(table, row.original.lastSeenDateTime),
    },
    {
      id: 'Location Method',
      accessorKey: 'locationMethodDescr',
      header: 'Location Method',
      size: 70,
      cell: ({ row }) => (
        <span style={{ textAlign: 'center' }} title={row.original.locationMethodDescr}>
          {renderLocationMethod(row.original.locationMethod)}
        </span>
      ),
    },
    {
      header: 'Latitude',
      accessorKey: 'location.latitude',
      disableSortBy: true,
      enableColumnFilter: true,
      size: 100,
    },
    {
      header: 'Longitude',
      accessorKey: 'location.longitude',
      disableSortBy: true,
      enableColumnFilter: true,
      size: 100,
    },
    {
      header: 'Rssi',
      accessorKey: 'rssi',
      enableColumnFilter: false,
      size: 40,
      style: { textAlign: 'center' },
    },
    {
      header: 'Battery',
      accessorKey: 'batteryPercent',
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const percentage = row.original.batteryPercent ?? 0;
        const color = percentage >= 80 ? 'green' : percentage <= 20 ? 'red' : percentage <= 30 ? 'orange' : '';
        return <span style={{ color: color }}>{percentage}%</span>;
      },
    },
    {
      header: 'Bat. Voltage',
      accessorKey: 'batteryVoltage',
      size: 90,
      style: { textAlign: 'center' },
      cell: ({ row }) => <>{row.original.batteryVoltage && <>{row.original.batteryVoltage} V</>}</>,
    },
    {
      header: 'Humidity',
      accessorKey: 'humidity',
      enableColumnFilter: false,
      size: 70,
    },
    {
      header: 'Temp',
      accessorKey: 'temperatureC',
      enableColumnFilter: false,
      size: 60,
    },
    {
      header: 'Light',
      accessorKey: 'light',
      enableColumnFilter: false,
      size: 60,
    },
    {
      header: 'Press',
      accessorKey: 'pressure',
      enableColumnFilter: false,
      cell: ({ row }) => <>{row.original.pressure ?? ''}</>,
    },
  ] as Array<any>;

  return col;
};
